import { render, staticRenderFns } from "./ScaniaDisplay.vue?vue&type=template&id=a19b98b8&"
import script from "./ScaniaDisplay.vue?vue&type=script&lang=js&"
export * from "./ScaniaDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports